import styled, { css } from 'styled-components';
import { TableHeader } from '../../base/table/table';

export const Wrapper = styled.div`
	/* min-width: 75rem; */
	overflow-y: visible;
	overflow-x: scroll;
`;

export const CustomTableHeader = styled(TableHeader)`
	text-align: center;
	${({ white, theme }) =>
		white &&
		css`
			color: ${theme.colors.white};
		`};
`;
